import { render, staticRenderFns } from "./radioField.vue?vue&type=template&id=18906632&"
import script from "./radioField.vue?vue&type=script&lang=ts&"
export * from "./radioField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports